export default class TipMsg {}

TipMsg.SEND_SECRET_SUC = '独立密码已短信发送至密保手机';
TipMsg.SEND_SMS_CODE_SUC = '验证码已短信发送至密保手机';
TipMsg.UPDATE_SECRET_SUC = '独立密码设置成功';
TipMsg.UPDATE_MOBILE_SUC = '密保手机设置成功';
TipMsg.MOBILE_PARAM_ERROR = '手机号格式不正确';
TipMsg.NO_RIGHT = '没有当前页面权限';
TipMsg.SECOND_PSW_ERROR = '请输入正确的独立密码';
TipMsg.SMS_CODE_PARAM_ERROR = '验证码格式不正确';
TipMsg.SECOND_PSW_PARAM_ERROR = '独立密码格式不正确';
TipMsg.DELETE_SECRET_SUC = '独立密码取消成功';

Object.freeze(TipMsg);
